<script>
import { fromDate } from '@/mixins/formatDateTime'
import { datetime } from '@/config'

export default {
  functional: true,
  props: {
    date: {
      type: [String, Object],
      default: () => ({}),
      requred: true,
    },
    placeholder: {
      type: String,
      default: '—',
    },
  },
  render: function (h, { props }) {
    const date = fromDate(props.date, datetime.FORMAT_DATE) || props.placeholder
    const time = fromDate(props.date, datetime.FORMAT_TIME) || props.placeholder

    return h(
      'div',
      {
        attrs: {
          title: props.date ? `Время: ${time}` : false,
        },
      },
      date
    )
  },
}
</script>
